import { LOCALE } from '../constants/settings';

export const getLocale = () => {
  return {
    locale: typeof window !== 'undefined' ? localStorage.getItem(LOCALE) : '',
  };
};

export const setLocale = (locale: string) => {
  if (typeof window !== 'undefined') localStorage.setItem(LOCALE, locale);
};
